import { css } from 'lit';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
  :host {
    --font-size-regular: 18px; 
  }
.endpoint-head .descr {
    font-size: 16px;
}
`;
